import { Card, Flex, Inset } from "@radix-ui/themes";
import Link from "next/link";
import { Image } from "react-datocms/image";
import { StructuredText } from "react-datocms/structured-text";

const DocsCard = ({card}) => {
    return <><Link href={card.url} className="docs-card">
        <Card>
            {card.image && <Inset side="top">
                <Image data={card.image.responsiveImage}/>
            </Inset>}
            <Flex direction="column" gap="3" p="3">
                <span className="material-symbols-rounded">{card.icon}</span>
                <h3>{card.title}</h3>
                <StructuredText data={card.description} />
            </Flex>
        </Card>
    </Link><style jsx>
        {`
            :global(a.docs-card) {
                text-decoration: none;
                flex: 1 1 250px;
                height: auto;
                display: flex;
                width: 100%;
                transition: 0.2s;
                box-shadow: 0 0px 0px 0px;
            }
            :global(a.docs-card:hover) {
                box-shadow: 0 5px 10px -10px;
                transition: 0.2s;
            }
            .material-symbols-rounded {
                color: var(--pink);
            }
        `}
    </style></>;
};

export {DocsCard};